export default "__VITE_ASSET__CbMsStAB__"